export const sumTaxItemsByDirection = (concepts = [], expectedDirection = '') => {
  return (Array.isArray(concepts) ? concepts : []).reduce((sum, concept) => {
    const items = Array.isArray(concept?.taxes?.items) ? concept.taxes.items : [];

    const conceptAmount = items.reduce((itemsSum, item) => {
      const direction = String(item?.direction || '').trim().toLowerCase();
      if (direction !== expectedDirection) {
        return itemsSum;
      }

      const amount = Number(item?.amount || 0);
      return itemsSum + (Number.isFinite(amount) ? amount : 0);
    }, 0);

    return sum + conceptAmount;
  }, 0);
};

export const buildInvoiceDetailHeaderActions = (labels = {}) => {
  return [
    {
      key: 'pay',
      label: String(labels.pay || 'Pagar'),
      icon: 'fa-credit-card',
      variant: 'success',
    },
    {
      key: 'downloadPdf',
      label: String(labels.downloadPdfShort || 'PDF'),
      icon: 'fa-file-pdf-o',
      variant: 'secondary',
    },
    {
      key: 'download',
      label: 'Descargar PDF y XML',
      icon: 'fa-download',
      variant: 'secondary',
      iconOnly: true,
      title: 'Descargar PDF y XML',
    },
    {
      key: 'downloadXml',
      label: 'XML',
      icon: 'fa-file-code-o',
      variant: 'secondary',
    },
    {
      key: 'send',
      label: String(labels.send || 'Enviar'),
      icon: 'fa-paper-plane-o',
      variant: 'primary',
    },
    {
      key: 'clone',
      label: String(labels.clone || 'Clonar'),
      icon: 'fa-clone',
      variant: 'secondary',
    },
    {
      key: 'sendWhatsapp',
      label: String(labels.sendWhatsapp || 'Enviar por WhatsApp'),
      icon: 'fa-whatsapp',
      variant: 'secondary',
    },
    {
      key: 'cancel',
      label: String(labels.cancel || 'Cancelar'),
      icon: 'fa-ban',
      variant: 'secondary',
    },
  ];
};
